/* Shared, site-wide auth affordance. Logged out → a "Sign in" link (remembering
 * the current page so login can return here). Logged in → the user's email + a
 * "Sign out" button. Used in the public landing topbar and the admin sidebar
 * footer; `variant` only switches presentation. */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import "./auth.css";

function initials(email: string): string {
  return email.slice(0, 2).toUpperCase();
}

export function AccountControl({
  variant,
}: {
  variant: "topbar" | "footer";
}): React.ReactElement | null {
  const { user, loading, canAccessAdmin, signOut } = useAuth();
  const location = useLocation();

  // Avoid a sign-in/out flash before the initial session check resolves.
  if (loading) return null;

  const from = location.pathname + location.search;

  if (!user) {
    return (
      <Link
        className={variant === "topbar" ? "acct-btn acct-signin" : "nav-btn"}
        to="/login"
        state={{ from }}
      >
        Sign in
      </Link>
    );
  }

  if (variant === "footer") {
    return (
      <div className="side-user">
        <div className="avatar">{initials(user.email ?? "?")}</div>
        <div>
          <div className="u-nm">{user.email}</div>
          <button className="u-rl acct-linkbtn" onClick={() => signOut()}>
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="acct">
      {canAccessAdmin && (
        <Link className="acct-btn acct-signin" to="/admin">
          Admin
        </Link>
      )}
      <span className="acct-email">{user.email}</span>
      <button className="acct-btn" onClick={() => signOut()}>
        Sign out
      </button>
    </div>
  );
}
